module.exports = __webpack_public_path__ + "static/media/polls-infographic-highlighted.bd1f222d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/images/polls-infographic-highlighted.png
// module id = 261
// module chunks = 1